function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} HelpUp. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
